import React from 'react';
import { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import * as S from './GenericSelect.styles';

type Value = string | number | boolean;

export type Option = { label: string; value: Value; disabled?: boolean };

interface GenericSelectProps extends Omit<Props, 'value'> {
  value?: Value | null;
  onChange: (value: Option, meta: ActionMeta<Option>) => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
  options: Option[];
  white?: boolean;
  width?: number;
  isLoading?: boolean;
  menuAutoWidth?: boolean;
}

export const GenericSelect: React.FC<GenericSelectProps> = ({
  value,
  onChange,
  error,
  helperText,
  disabled,
  placeholder = 'Select',
  options,
  white,
  width,
  isLoading,
  menuAutoWidth,
  styles,
  ...rest
}) => {
  const menuAutoWidthStyles = menuAutoWidth
    ? {
        menu: (base: object) => ({
          ...base,
          width: 'max-content',
          minWidth: '100%',
        }),
        option: (base: object) => ({
          ...base,
          whiteSpace: 'nowrap' as const,
        }),
      }
    : {};

  return (
    <>
      <S.StyledSelect
        isDisabled={disabled}
        isLoading={isLoading}
        value={_.find(options, (o) => o.value === value)}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
        $white={white}
        isOptionDisabled={(o: Option) => o.disabled}
        $width={width}
        styles={{ ...menuAutoWidthStyles, ...styles }}
        {...rest}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
